import styled from 'styled-components';

export const AuthForm = styled.form`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
`;
